var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    viewBox: "0 0 295 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 295,
    rx: 78.2653,
    fill: "url(#paint0_linear_937_1836)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.491 83.7996H108.571V175.974H186.491V83.7996ZM95.2676 70.4961V189.277H199.795V70.4961H95.2676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.824 105.707L95.2676 70.4961V189.277L160.824 224.488V105.707Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_1836",
    x1: 147.5,
    y1: 0,
    x2: 147.5,
    y2: 295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD954A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconSm);
export default __webpack_public_path__ + "static/media/logo-icon-sm.17cfc634fd33b1a6d8598a3c3da51a5a.svg";
export { ForwardRef as ReactComponent };